import { render } from "./list-notification.vue?vue&type=template&id=7bd8bdd1"
import script from "./list-notification.vue?vue&type=script&lang=js"
export * from "./list-notification.vue?vue&type=script&lang=js"

import "./list-notification.vue?vue&type=style&index=0&id=7bd8bdd1&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__